import React from 'react'
import styles from './CustomHeader.module.scss'

/**
 * CustomHeader - AG Grid custom header component
 * Renders custom header content when headerRender is provided in column definition
 *
 * This component is only used when a column has a headerRender function.
 * Columns without headerRender use the default AG Grid header.
 */
const CustomHeader = (props) => {
    const { headerRender, column, displayName } = props

    // If headerRender is provided, use it
    if (headerRender && typeof headerRender === 'function') {
        return (
            <div className={styles.customHeader}>
                {headerRender({
                    column,
                    displayName,
                    api: props.api,
                    columnApi: props.columnApi,
                })}
            </div>
        )
    }

    // Fallback to default display (shouldn't happen, but safety first)
    return <div className={styles.customHeader}>{displayName}</div>
}

export default CustomHeader
